var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookColorful = function SvgFacebookColorful(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1181240_facebook_social_social application_social media_social network_icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0005 2.36084C6.6802 2.36084 2.36719 6.67651 2.36719 11.9998C2.36719 17.323 6.6802 21.6392 12.0005 21.6392C17.3207 21.6392 21.6341 17.3232 21.6341 11.9998C21.6339 6.67651 17.3207 2.36084 12.0005 2.36084ZM15.2904 8.52667C15.2904 8.61867 15.2159 8.69334 15.1238 8.69334H12.7787V9.95451H15.1237C15.2158 9.95451 15.2902 10.0292 15.2902 10.1212V12.4673C15.2902 12.5595 15.2158 12.634 15.1237 12.634H12.9453V17.7827C12.9453 17.8748 12.8708 17.9493 12.7787 17.9493H10.5625C10.4704 17.9493 10.3959 17.8748 10.3959 17.7827V12.6342H8.87727C8.78516 12.6342 8.7107 12.5597 8.7107 12.4675V10.1213C8.7107 10.0293 8.78516 9.95467 8.87727 9.95467H10.3959V9.00334C10.3959 8.98967 10.3976 8.97651 10.4006 8.96384C10.4019 7.60867 10.6916 6.05834 12.9104 6.05134C12.9153 6.05101 12.9204 6.05067 12.9254 6.05067H15.1237C15.2158 6.05067 15.2902 6.12534 15.2902 6.21734L15.2904 8.52667Z",
    fill: "#2555EF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookColorful, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebookColorful.e287a5dd.svg";
export { ForwardRef as ReactComponent };